import { router } from '@inertiajs/vue3';
import { getUser } from '@/app/helpers/userHelper';

/**
 * 네비게이션 정보 타입
 */
export interface NavigationInfo {
    url: string;
    timestamp: number;
    expire_at?: number;
}

/**
 * 학생 ID를 기반으로 네비게이션 타임스탬프 키를 생성합니다.
 *
 * @param studentId - 학생 ID
 * @returns 네비게이션 타임스탬프 키
 */
export function getNavigationTimestampKey(studentId: number): string {
    return `navigationTimestamp_${studentId}`;
}

/**
 * 네비게이션 타임스탬프를 sessionStorage에 저장합니다.
 *
 * @param studentId - 학생 ID
 * @param timestamp - 타임스탬프 값
 */
export function saveNavigationTimestamp(studentId: number, timestamp: number): void {
    const navigationTimestampKey = getNavigationTimestampKey(studentId);
    sessionStorage.setItem(navigationTimestampKey, timestamp.toString());
}

/**
 * 선생님이 이동 시킨 페이지로 이동
 * 이미 이동한 페이지이면 무시
 *
 * @param navigation - 네비게이션 정보 (null일 수 있음)
 */
export function checkNavigation(navigation: NavigationInfo | null) {
    if (!navigation) {
        return;
    }

    const studentId = getUser().id;
    const navigationTimestampKey = getNavigationTimestampKey(studentId);
    const navigationTimestamp = sessionStorage.getItem(navigationTimestampKey);

    const currentUrl = window.location.href;

    if (Number(navigationTimestamp) !== navigation.timestamp && currentUrl !== navigation.url) {
        router.get(
            navigation.url,
            {},
            {
                replace: true,
                onFinish: () => {
                    saveNavigationTimestamp(studentId, navigation.timestamp);
                },
            },
        );
    }
}
